import React from "react";
import clsx from "classnames";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import Body from "@/ui/Body";
import PatternPlus from "@/assets/1_b.svg";
import PatternTwo from "@/assets/1_a.svg";
import Image from "@/ui/Image";
import Button from "../Button";

const ContentSection = ({
  className,
  image,
  alignment,
  title,
  highlight,
  color_variant,
  button1_text,
  button1_link,
  button2_text,
  button2_link,
  description,
  alt_text,
}) => {
  function reverse() {
    return alignment == "image_left" ? classes.reverse : "";
  }

  function button1() {
    return <Button icon={true} display={button1_text} link={button1_link} variant={color_variant}></Button>;
  }

  function button2() {
    return <Button icon={true} display={button2_text} link={button2_link} variant={color_variant}></Button>;
  }

  return (
    <div className={clsx(className, classes.section, reverse())}>
      <div className={classes.content}>
        <Title className={classes.title} title={title} tag="h4" highlight={highlight} variant={color_variant} />
        <Body body={description} />
        {button1_text && (
          <div className={classes.ctas}>
            {button1_text && button1()}
            {button2_text && button2()}
          </div>
        )}
      </div>
      <div className={classes.image_content}>
        {!reverse() ? (
          <>
            <PatternPlus className={`fill ${color_variant} ${classes.pattern_small}`} />
            <PatternTwo className={`fill ${color_variant} ${classes.pattern_large}`} />
          </>
        ) : (
          ""
        )}

        <div className={classes.image_cont}>
          <Image img={image} alt={alt_text} size="562x332" className={classes.image} />
          <div className={`overlay ${classes.overlay} ${color_variant}`}></div>
        </div>
      </div>
    </div>
  );
};

export default ContentSection;
